import classnames from 'classnames';
import type { FC } from 'react';
import React, { useContext } from 'react';

import {
  RicosAlignmentContext,
  RicosNodeContext,
  RicosNodeContextProvider,
  RicosViewerContext,
} from './../../../../../ricos-context/index.js';
import type { NodeStyle } from './../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { TextStyle_TextAlignment } from './../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../../../../ricos-types/index.js';
import { normalizeLineHeight } from './../../../../../_shared/line-spacing-utils.js';

import alignmentStyle from '../../../../statics/alignment-scss.js';
import Anchorable from '../../utils/Anchorable.js';
import { getPaywallSeoClass, isPaywallSeo } from '../../utils/paywallSeo.js';
import styles from './codeblock-scss.js';

const CodeBlock: FC<NodeViewRendererProps> = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { seoMode } = useContext(RicosViewerContext);
  const { textAlignment: parentAlignment } = useContext(RicosAlignmentContext);
  const { parentNode } = useContext(RicosNodeContext);
  const { textAlignment, lineHeight } = node.codeBlockData?.textStyle || {};
  const codeBlockClassName = classnames(
    styles.codeBlock,
    alignmentStyle[textAlignment || parentAlignment || TextStyle_TextAlignment.AUTO],
    !parentNode && isPaywallSeo(seoMode) && getPaywallSeoClass(seoMode?.paywall || {}, nodeIndex)
  );

  const nodeStyle: NodeStyle & { lineHeight?: string } = {
    ...node.style,
    ...(lineHeight && { lineHeight: normalizeLineHeight(lineHeight) }),
  };
  return (
    <Anchorable nodeId={node.id}>
      <pre className={codeBlockClassName} style={nodeStyle} dir="auto">
        <span
          className={classnames(
            textAlignment === TextStyle_TextAlignment.JUSTIFY && alignmentStyle[textAlignment]
          )}
        >
          <RicosNodeContextProvider parentNode={node} parentIndex={nodeIndex}>
            <RicosNodesRenderer nodes={node.nodes ?? []} />
          </RicosNodeContextProvider>
        </span>
      </pre>
    </Anchorable>
  );
};

const CodeBlockRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <CodeBlock key={node.id} node={node} {...props} />;
};

export default CodeBlockRenderer;
